import { render, staticRenderFns } from "./Viphandup.vue?vue&type=template&id=c6c14162&scoped=true"
import script from "./Viphandup.vue?vue&type=script&lang=js"
export * from "./Viphandup.vue?vue&type=script&lang=js"
import style0 from "./Viphandup.vue?vue&type=style&index=0&id=c6c14162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c14162",
  null
  
)

export default component.exports